import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useClient } from '../../client-api';
import { createSurplusItem, type SurplusItemSettingsCreateDto, type SurplusItemSettingsDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useCreateSurplusItem = (): UseMutationResult<SurplusItemSettingsDto, AxiosError, SurplusItemSettingsCreateDto> => {
    const queryClient = useQueryClient();
    const { data: client } = useClient();

    return useMutation({
        mutationFn: (payload) =>
            createSurplusItem({
                body: {
                    ...payload,
                    clientId: client?.id ?? -1,
                },
            }).then((result) => result.data!),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.surplusPanelSettings(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.cashFlow(client?.partnerUuid) });
            queryClient.invalidateQueries({ queryKey: queryKeys.projection(client?.partnerUuid) });
        },
    });
};
